/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MissingInfoFollowUp } from './MissingInfoFollowUp';
import {
    MissingInfoFollowUpFromJSON,
    MissingInfoFollowUpFromJSONTyped,
    MissingInfoFollowUpToJSON,
    MissingInfoFollowUpToJSONTyped,
} from './MissingInfoFollowUp';

/**
 * 
 * @export
 * @interface MissingInfoFollowUpList
 */
export interface MissingInfoFollowUpList {
    /**
     * 
     */
    active: Array<MissingInfoFollowUp>;
}

/**
 * Check if a given object implements the MissingInfoFollowUpList interface.
 */
export function instanceOfMissingInfoFollowUpList(value: object): value is MissingInfoFollowUpList {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function MissingInfoFollowUpListFromJSON(json: any): MissingInfoFollowUpList {
    return MissingInfoFollowUpListFromJSONTyped(json, false);
}

export function MissingInfoFollowUpListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingInfoFollowUpList {
    if (json == null) {
        return json;
    }
    return {
        
        'active': ((json['active'] as Array<any>).map(MissingInfoFollowUpFromJSON)),
    };
}

export function MissingInfoFollowUpListToJSON(json: any): MissingInfoFollowUpList {
    return MissingInfoFollowUpListToJSONTyped(json, false);
}

export function MissingInfoFollowUpListToJSONTyped(value?: MissingInfoFollowUpList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': ((value['active'] as Array<any>).map(MissingInfoFollowUpToJSON)),
    };
}

